import React, { Component } from 'react'
import PropTypes from 'prop-types'
import UUID from 'uuid'
import { formatNumber, nFormatter } from '../../../utils/NumberUtils'
import { LEFT_POSITION } from '../../../utils/PositionConstants'

class IndicatorTile extends Component {

	componentDidUpdate() {
		$('.tooltipped.tile-tooltip').tooltip({ delay: 50 })
	}

	render() {
		const value = (() => {
			if (this.props.text) {
				return (
					<span className='timer white-numbers'>{ this.props.text }</span>
				)
			}
			return (
				<span className='timer white-numbers tooltipped tile-tooltip' data-position='top'
					  data-tooltip={ formatNumber(this.props.number) }>{ nFormatter(this.props.number) }</span>
			)
		})()
		const position = (() => {
			if (this.props.titlePosition) {
				return this.props.titlePosition
			}
			return LEFT_POSITION
		})()
		const title = (<span className='blue-title light'>
							{ this.props.title }
						</span>)
		const tabValue = (() => {
			switch (position) {
				case LEFT_POSITION:
					return [title, value]
				default:
					return [value, title]
			}
		})()
		return (
			<div key={ UUID.v4() } className={ 'col s4 blue-card-light no-padding center-align' }>
				{ tabValue[0] } &nbsp; { tabValue[1] }
			</div>
		)
	}

    componentWillUnmount() {
        $('.tooltipped.tile-tooltip').tooltip('remove')
    }
}

IndicatorTile.propTypes = {
	title: PropTypes.string,
	titlePosition: PropTypes.string,
	number: PropTypes.number,
	text: PropTypes.string
}

IndicatorTile.defaultProps = {
	title: '',
	titlePosition: LEFT_POSITION,
	number: 0,
	text: ''
}

export default IndicatorTile



// WEBPACK FOOTER //
// ./src/dashboard/components/indicator/IndicatorTile.js